<template>
	<div class="page" data-name="idpw">
		<div class="page-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					ID & PASSWORD 찾기
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
			</f7-navbar>

			<div class="block-title">ID 찾기</div>
			<div class="list  no-hairlines">
				<ul>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">이름 입력</div>
							<div class="item-input-wrap">
								<input type="text" name="userName" ref="userName">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>		
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">비밀번호 질문 선택</div>							
							<div class="item-input-wrap input-dropdown-wrap">
								<select name="pwQuestion" ref="pwQuestion">
									<option value="">선택</option>
									<option value="a">출신초등학교는?</option>
									<option value="b">어머님성함은?</option>
									<option value="c">가장친한친구이름은?</option>
									<option value="d">태어난곳은?</option>
								</select>
							</div>
						</div>
					</li>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">답변 입력</div>
							<div class="item-input-wrap">
								<input type="text" name="pwAnswer" ref="pwAnswer">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>	
					<li class="item-content item-input item-input-outline">      						
						<div class="item-inner">
							<div class="item-title item-floating-label">EMAIL을 입력</div>
							<div class="item-input-wrap">
								<input type="email" name="email" ref="email">
								<span class="input-clear-button"></span>
							</div>
						</div>						
    			</li>	
					<li class="item-content item-input item-input-outline">
						<div class="item-inner">				
							<button class="button button-fill " v-on:click="findUserId">ID 찾기</button>				
						</div>
					</li>	
				</ul>
			</div>

			<div class="block-title">Password 찾기 (<mark>비밀번호는 암호화 되어 저장 되므로 본사에서 초기화 진행후 연락드리겠습니다.</mark>)</div>
			<div class="list">
				<ul>
					<li>
						<a href="#" class="item-link item-content popup-open" data-popup=".collect-use-popup"> 
							<div class="item-inner">
            		<div class="item-title">개인정보 수집 동의</div>
								<div class="item-after">{{collectUseAgreement ? '동의' : '미동의'}}</div>
        			</div>
						</a>
					</li>
				</ul>
			</div>
			<div class="list  no-hairlines">
				<ul>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">이름 입력</div>
							<div class="item-input-wrap">
								<input type="text" name="passUserName" ref="passUserName">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>	
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">아이디 입력</div>
							<div class="item-input-wrap">
								<input type="text" name="userId" ref="userId">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>	
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">휴대폰번호 입력</div>
							<div class="item-input-wrap">
								<input type="text" name="mobile" ref="mobile" v-on:keyup="keyPress($event,'MOBILE')"  :maxlength="phoneMax">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>	
					<li class="item-content item-input item-input-outline">
						<div class="item-inner">				
							<button class="button button-fill " v-on:click="findUserPassword">전송</button>				
						</div>
					</li>	
				</ul>
			</div>
		</div>

		<div class="popup collect-use-popup" id="collect-use-popup">
			<div class="view">
				<div class="page">
					<div class="navbar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner">
							<div class="title">개인정보 수집</div>
							<div class="right">								
								<a class="link popup-close">닫기</a>
							</div>
						</div>
					</div>
					<div class="page-content">
					<p>
						개인정정보 수집 및 동의 관련 내용 삽입
					</p>
					<div class="list">
						<ul>
							<li>
								<label class="item-checkbox item-content">
									<div class="item-inner">
										<div class="item-title">개인정보 수집에 동의 하십니까?</div>
									</div>
									<input type="checkbox"  value="ok" v-on:change="collectUseCheck"/>
									<i class="icon icon-checkbox"></i>						
								</label>
							</li>
						</ul>
					</div>
					</div>

				</div>
			</div>
		</div>	
	</div>
</template>


<script>
import MODULE from '../../js/common/module.js'
import Vue from 'vue';
import { f7 } from 'framework7-vue';
import CONST from '../../js/common/constant.js'
import AUTH from '../../js/common/auth.js'
import PAGES from '../../js/pages.js'
import API from '../../js/common/api.js'

export default {
	data() {
		return {
			collectUseAgreement: false,
			phoneMax: 13,
		}
	},
	mounted() {

	},
	methods:{
		collectUseCheck(event) {
			const _this = this;
			const element = event.currentTarget;

			if(element.checked){
				_this.collectUseAgreement = true;
				_this.$f7.popup.close("#collect-use-popup",true);
			}else{
					_this.collectUseAgreement = false;
			}
		},
		keyPress(event,type) {
			const _this = this;
			const element = event.currentTarget;

			if(type == "MOBILE"){
				const element = event.currentTarget;					
				element.value = MODULE.Util.autoHypenMobile(element.value);

			}
		},
		findUserId() {
			const _this = this;

			var userName = _this.$refs.userName.value;
			if(MODULE.Util.isEmpty(userName)){
				MODULE.DialogBox.warnToast("이름을 입력하셔야 합니다.");
				return false;	
			}

			var pwQuestion = _this.$refs.pwQuestion.value; 
			if(MODULE.Util.isEmpty(pwQuestion)){
				MODULE.DialogBox.warnToast("비밀번호 질문을 선택 하셔야 합니다.");
				return false;
			}

			var pwAnswer = _this.$refs.pwAnswer.value;
			if(MODULE.Util.isEmpty(pwAnswer)){
				MODULE.DialogBox.warnToast("비밀번호 질문에 대한 답변을 입력하셔야 합니다.");
				return false;
			}

			var email = _this.$refs.email.value;
			if(MODULE.Util.isEmpty(email)){
				MODULE.DialogBox.warnToast("이메일을 입력 하셔야 합니다.");						
			}

			if(!MODULE.Util.isValidEmail(email)){
				MODULE.DialogBox.warnToast("올바르지 않은 이메일 형식입니다.");
				return false;
			}		

			let param = {
				pUserName: userName,
				pPwQuestion: pwQuestion,
				pPwAnswer: pwAnswer,
				pEmail: email,				
			}

			MODULE.Ajax.request({
				url: API.findUserId(),
				data: param
			}).then(function (data){
				MODULE.DialogBox.message("정보","해당정보의 ID는 '" + data.USER_ID+"' 입니다.");
			}).catch(function (code){
				MODULE.DialogBox.message("정보", "해당 정보의 일치하는 아이디가 없습니다.");		
			});
		},
		findUserPassword() {
			const _this = this;

			if(!_this.collectUseAgreement){
				MODULE.DialogBox.warnToast("개인정보 수집에 동의하셔야 합니다.");
				return false;	
			}

			var userName = _this.$refs.passUserName.value;
			if(MODULE.Util.isEmpty(userName)){
				MODULE.DialogBox.warnToast("이름을 입력하셔야 합니다.");
				return false;	
			}

			var userId = _this.$refs.userId.value;
			if(MODULE.Util.isEmpty(userId)){
				MODULE.DialogBox.warnToast("아이디를 입력하셔야 합니다.");
				return false;	
			}

			
			var mobile = _this.$refs.mobile.value;
			if(MODULE.Util.isEmpty(mobile)){
				MODULE.DialogBox.warnToast("휴대폰 번호를 입력 하셔야 합니다.");								
			}

			if(!MODULE.Util.isValidMobile(mobile)){
				MODULE.DialogBox.warnToast("휴대폰번호가 올바르지 않습니다.");
				return false;
			}
			MODULE.DialogBox.message("알림", "전송되었습니다. 처리 후 전송하신 번호로 회신드리겠습니다.");

		}
	}
	
}
</script>